import { ProjectFile } from './ProjectFile'
import { newObjectId } from './Utils'
import {Language} from "./Language";

export interface Project {
    id: number
    projectName: string
    defaultLanguage: number
    languages: Record<number, Language>
    projectFilesExpanded: Array<ProjectFile>
}

export function createProject(): Project {
    return {
        id: newObjectId,
        projectName: '',
        defaultLanguage: 0,
        languages: {},
        projectFilesExpanded: []
    }
}
